<template>
  <div class="">
    <!-- <Dashbaord /> -->
    <CompanyTable />
    <!-- <PopupButton/> -->
  </div>
</template>

<script>
import Dashbaord from "./components/Dashbaord.vue";
import CompanyTable from "./components/CampanyTable.vue";
import PopupButton from "./components/PopupButton.vue";

export default {
  components: {
    Dashbaord,
    CompanyTable,
    PopupButton,
  },
};
</script>
